import { FileContainer, FileWithPreview, PreparedDescription } from 'Modules'

export const getResultFile = (
	acceptedFiles: FileWithPreview[],
	maxFilesCount: number,
	filesFormState?: FileWithPreview[]
) => {
	const files = filesFormState || []
	return maxFilesCount === 1
		? acceptedFiles[0]
		: files.concat(acceptedFiles).slice(0, maxFilesCount)
}

export const prepareFileDescr = (descriptionsArray: string[]): PreparedDescription => {
	return descriptionsArray.join(' • ')
}

export const getFilesFromContainer = (list: FileContainer[]) => list.map((file) => file.file)
